import React from "react";
import { ContextState } from "./AppContextProvider";
export const AppContext = React.createContext<ContextState>({
  localAppState: { activeButtonID: 1 },
  setLocalAppState: () => null,
});
export default AppContext;
